import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { objectToCssString } from "./utils";
const callUnmountFn = (unmountFn) => {
    if (typeof unmountFn === "function") {
        unmountFn();
    }
    else
        console.warn("MFE should return an unmount function! Got instead:", typeof unmountFn);
};
export const RenderMFE = ({ loadRender, basePath, errorCallback = (e) => console.error(e), LoadingIndicator, Fallback, style, supportLoaderChanges, }) => {
    const [element, setElement] = useState(null);
    const [render, setRender] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const assignRender = () => loadRender()
        .then((x) => {
        if (typeof x !== "function") {
            return Promise.reject("RenderMFE: loadRender() did not return a function.");
        }
        setRender(() => x);
    })
        .catch((err) => {
        setError(err);
        errorCallback(err);
    })
        .finally(() => {
        setLoading(false);
    });
    useEffect(() => {
        if (!supportLoaderChanges)
            assignRender();
    }, []);
    useEffect(() => {
        if (supportLoaderChanges) {
            // Reset error to avoid crashing page freezing on navigation
            setError(null);
            assignRender();
        }
    }, [assignRender]);
    useEffect(() => {
        if (!error && typeof render == "function" && element != null) {
            let error = null;
            setError(null);
            try {
                if (supportLoaderChanges) {
                    const newElement = document.createElement("div");
                    if (style) {
                        newElement.style.cssText = objectToCssString(style);
                    }
                    element.appendChild(newElement);
                    const unmountFn = render(newElement, { basePath });
                    return () => {
                        callUnmountFn(unmountFn);
                        element.removeChild(newElement);
                    };
                }
                const unmountFn = render(element, { basePath });
                return () => callUnmountFn(unmountFn);
            }
            catch (err) {
                error = err;
                try {
                    errorCallback(err);
                }
                catch (err2) {
                    console.error(err);
                    console.error(err2);
                    // We want to prioritize reporting of this error since it would be
                    // hidden by fixing the first.
                    error = err2;
                }
                setError(error);
            }
        }
    }, [render, element, error]);
    return (_jsxs(_Fragment, { children: [error && _jsx(Fallback, { error: error }), _jsx("div", { style: style, ref: setElement }, basePath), LoadingIndicator && (loading || !element) && !error && (_jsx(LoadingIndicator, {}))] }));
};
